package org.braunequip.web.components.forms.Maintenance

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import kotlinx.datetime.*
import org.braunequip.web.components.models.AssetDTO
import org.braunequip.web.components.models.CompleteMaintItemRequest
import org.braunequip.web.components.models.MaintItemsDTO
import org.braunequip.web.util.Constants
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.Theme
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement
import kotlin.js.Date

@Composable
fun ConfirmMaintItemModal(
    asset: AssetDTO,
    item: MaintItemsDTO,
    subText: String = "Completing will generate new maintenance item according to the schedule, and miles/due date:",
    onConfirm: (CompleteMaintItemRequest) -> Unit,
    onDismiss: () -> Unit
) {
    var errorText by remember { mutableStateOf(" ") }
    val todayValue = Date().toISOString().substring(0, 10)

    var generateNextToggle by remember { mutableStateOf(true) }

    var completedState by remember { mutableStateOf(CompleteMaintItemRequest(
        maintItemId = item.id!!,
        scheduleId = item.scheduleId!!,
        assetId = item.assetId!!,
        currentMiles = if (item.dueMiles != null && item.dueMiles!! >= asset.miles) item.dueMiles else asset.miles,
        completionDate = todayValue
    )) }

    Box(
        modifier = Modifier
            .width(100.vw)
            .height(100.vh)
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .zIndex(19),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(700.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically
            ) {
                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }

            H2(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(1.25.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text("Complete Maintenance Item")
            }

            H2(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY2)
                    .margin(topBottom = 12.px)
                    .fontSize(1.45.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text(item.scheduleName!!)
            }

            H3(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .margin(bottom = 6.px)
                    .toAttrs()
            ) {
                Text(subText)
            }



            H3(
                attrs = Modifier
                    .color(if (item.dueMiles == null) Colors.Grey else Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Miles Completed At:")
            }


            Input(
                type = InputType.Number,
                attrs = Modifier
                    .id(InputIDs.MaintenanceItems.completedMiles)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .disabled(item.dueMiles == null)
                    .toAttrs {
                        attr("placeholder", "Miles Completed At")
                        attr(
                            attr = "value",
                            value = completedState.currentMiles.toString()
                            // Set value from DTO or asset, depending which is higher!
                        )
                    }
            )


            H3(
                attrs = Modifier
                    .color(Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Date Completed At")
            }


            Input(
                type = InputType.Date,
                attrs = Modifier
                    .id(InputIDs.MaintenanceItems.completedDueDate)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Day Completed")
                        attr("value", todayValue) // Set value from DTO
                    }
            )

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Input(
                    type = InputType.Checkbox,
                    attrs = Modifier
                        .height(15.px)
                        .width(15.px)
                        .margin(
                            right = 12.px,
                        )
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(16.px)
                        .onClick {
                            generateNextToggle = !generateNextToggle
                        }
                        .toAttrs{
                            attr("checked", "true")
                        }
                )

                H3(
                    attrs = Modifier
                        .color(Colors.Black)
                        .fontFamily(FONT_FAMILY)
                        .fontSize(1.cssRem)
                        .fontWeight(FontWeight.Medium)
                        .toAttrs()
                ) {
                    Text("Generate Next Item")
                }
            }

            H3(
                attrs = Modifier
                    .color(if (!generateNextToggle) Colors.Red else Colors.Transparent)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(0.75.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .textAlign(TextAlign.Center)
                    .margin(topBottom = 4.px)
                    .toAttrs()
            ) {
                Text("Warning: Will remove maintenance schedule from asset!")
            }

            SpanText(
                modifier = Modifier
                    .width(350.px)
                    .margin(topBottom = 8.px)
                    .fontFamily(FONT_FAMILY2)
                    .color(Colors.Black)
                    .textAlign(TextAlign.Center),
                text = errorText
            )

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceEvenly
            ) {
                Button(
                    attrs = Modifier
                        .classNames("button")
                        .backgroundColor(Theme.Primary.rgb)
                        .color(Colors.White)
                        .onClick {
                            errorText = " "

                            val completedMiles = (document.getElementById(InputIDs.MaintenanceItems.completedMiles) as HTMLInputElement).value
                            val validDate = try {
                                val dateStr = (document.getElementById(InputIDs.MaintenanceItems.completedDueDate) as HTMLInputElement).value
                                val date = LocalDate.parse(dateStr)

                                val localDate = LocalDate.parse(dateStr)
                                val currentTime = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).time

                                LocalDateTime(date, currentTime)
                            } catch (e: Exception) {
                                null
                            }


                            if ((completedMiles.isNotBlank() && completedMiles.isNotEmpty())) {
                                completedState = completedState.copy(
                                    currentMiles = completedMiles.toInt()
                                )

                                if (validDate != null) {
                                    completedState = completedState.copy(
                                        completionDate = validDate.toString()
                                    )

                                    onConfirm(completedState)
                                } else {
                                    errorText = "Please entered valid date!"
                                }
                            } else {
                                errorText = "Please entered valid miles amount!"
                            }
                        }
                        .toAttrs()
                ) {
                    Text("Confirm")
                }

                Button(
                    attrs = Modifier
                        .classNames("button")
                        .backgroundColor(Colors.LightGray)
                        .color(Colors.White)
                        .onClick {
                            onDismiss()
                        }
                        .toAttrs()
                ) {
                    Text("Cancel")
                }
            }

        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}